



















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MallShoppingCartIcon from "@/components/modules/mall/shopping-cart/MallShoppingCartIcon.vue";
import { browserBack } from "@/utils/native/interaction";
import { AppStore } from "@/store/namespace";
import { TypeClass } from "@/utils/common";
import tinycolor from "tinycolor2";

@Component({
  components: {
    MallShoppingCartIcon
  },
  methods: {
    browserBack
  }
})
export default class WtHeader extends Vue {
  // 当组件用
  @Prop({ type: Boolean, default: false }) showProp: boolean;
  @Prop({ type: Boolean, default: true }) fixedProp: boolean;

  @AppStore.State title: string;
  @AppStore.State platform: string;

  public titleColor = "";

  get showHeader() {
    return (
      this.$route.meta?.showHeader || this.$route.query?.header || this.showProp
    );
  }

  @Watch("$route")
  onRouteChange() {
    const bgColor = this.getBackground || "#FFF";
    // 透明度为0，就不设置statusBar
    const bgColorTinyInstance = tinycolor(bgColor);
    if (bgColorTinyInstance.getAlpha()) {
      const bgIsLight = bgColorTinyInstance.isLight();
      // 设置 title 文字颜色
      bgIsLight
        ? (this.titleColor = "rgba(0, 0, 0, 0.87)")
        : (this.titleColor = "#FFF");
      // 设置状态栏颜色
      const transformBgColorForApp = bgColorTinyInstance.toHexString();
      window.nativeApp.setWebStausBarColor(transformBgColorForApp, bgIsLight);
    }
  }

  // 左侧返回点击
  get backFn() {
    const metaBackFn = this.$route.meta?.customBackFn;
    return metaBackFn ? metaBackFn.bind(this) : browserBack.bind(this);
  }

  // 右侧点击
  get rightClickFn() {
    const rightClick = this.$route.meta.rightClick;
    return rightClick ? rightClick.bind(this) : () => {};
  }

  get getBackground() {
    const bgColor = this.$route.meta.background;
    if (TypeClass.isFunction(bgColor)) {
      return bgColor(this.platform);
    }
    return bgColor;
  }
}
